module.exports = __webpack_public_path__ + "static/media/retirement-road-clear.daa39b1f.png";